export default
{
  "consoleLogFlag": true,
  "reduxLogFlag": true,
  "apiLogFlag": true,
  "apiStubFlag": false,
  "API_URL": " https://dev.evacuation-center-reception-service.jp/api/",
  "TIMEOUT_SECOND": 0,
  "API_MethodName_Evacuees": "evacuees",
  "API_MethodName_Evacuee": "evacuee",
  "Kintone_ApiId_Setai": 183,
  "Kintone_ApiId_Kojin": 185,
};
